import Properties from '@/components/Properties/BoxProperties';
import Send from '@/components/Properties/Groups/Arrange/Send';
import Rotate from '@/components/Properties/Groups/Arrange/Rotate';
import AlignmentGlobal from '@/components/Properties/Groups/AlignmentGlobal';
import Flip from '@/components/Properties/Features/Flip';
import Grouping from '@/components/Properties/Groups/Grouping';
import { useAppCommon, useElementProperties } from '@/hooks';
import { EVENT_TYPE, OBJECT_TYPE } from '@/common/constants';
export default {
  components: {
    Properties,
    Send,
    Rotate,
    Flip,
    Grouping,
    AlignmentGlobal
  },
  setup() {
    const { getProperty } = useElementProperties();
    const { isDigitalEdition, currentMultiSelectedObject } = useAppCommon();

    return {
      getProperty,
      isDigitalEdition,
      currentMultiSelectedObject
    };
  },
  data() {
    return {};
  },
  computed: {
    isDisableDistribute() {
      return (
        this.currentMultiSelectedObject.length < 3 ||
        this.getProperty('type') === OBJECT_TYPE.MULTI_OBJECT ||
        this.disableAlignment
      );
    },
    disableAlignment() {
      return this.getProperty('type') === OBJECT_TYPE.MULTI_OBJECT;
    },
    isGrouping() {
      return this.getProperty('type') === OBJECT_TYPE.MULTI_OBJECT;
    },
    rotateValue() {
      if (
        this.getProperty('type') === OBJECT_TYPE.MULTI_OBJECT &&
        this.getProperty('id')
      ) {
        return this.getProperty('coord').rotation;
      } else {
        const coord = this.currentMultiSelectedObject[0]?.coord?.rotation;
        const isDifferentAngle = this.currentMultiSelectedObject.find(
          o => Math.round(o.coord?.rotation) !== Math.round(coord)
        );
        return !isDifferentAngle ? coord : 0;
      }
    }
  },
  methods: {
    /**
     * Change align global property for objGroup selected
     *
     */
    onChange(val) {
      this.$root.$emit(EVENT_TYPE.ALIGN_GLOBAL_GROUP, val);
    },

    /**
     * Handle events when user click on "send" buttons
     * @param {String}  actionName indicated which type of "send" button was clicked
     */
    changeZIndex(actionName) {
      this.$root.$emit(EVENT_TYPE.CHANGE_OBJECT_IDS_ORDER, actionName);
    },
    /**
     * Emit group or ungroup state that is boolean value
     *
     */
    clickGroupButton(grouping) {
      this.$root.$emit(EVENT_TYPE.GROUPING, grouping);
    },

    /** Emit flip value to parent
     * @param {String}  actionName action name user clicked
     */
    changeFlip(actionName) {
      this.$root.$emit(EVENT_TYPE.FLIP_GLOBAL, actionName);
    },

    /** Emit angle value to parent
     */
    changeRotate(object) {
      this.$root.$emit(EVENT_TYPE.ROTATE_GLOBAL, object.coord?.rotation);
    }
  }
};
